module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6a3b3fd189cd9b61963721dc73b19829.png";